import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const testimonials = [
  {
    avatar: 'A',
    avatarBg: 'linear-gradient(135deg, #0C8F86, #087a72)',
    name: 'Andi Pratama',
    role: 'Trader Pemula · 3 Bulan',
    text: 'Sebelumnya saya selalu rugi trading karena tidak punya sistem. Setelah belajar di Tradiora dan mengikuti mentoring, sekarang saya bisa konsisten profit. AI Analysis-nya sangat membantu!',
    stars: 5,
  },
  {
    avatar: 'S',
    avatarBg: 'linear-gradient(135deg, #8b5cf6, #6d28d9)',
    name: 'Sari Wulandari',
    role: 'Investor · 1 Tahun',
    text: 'Platform yang sangat lengkap! Dari akademi, paper trading, sampai AI analysis. Saya suka fitur radar pasar yang memberikan notifikasi saham potensial setiap hari.',
    stars: 5,
  },
  {
    avatar: 'R',
    avatarBg: 'linear-gradient(135deg, #f59e0b, #d97706)',
    name: 'Rizky Firmansyah',
    role: 'Trader Aktif · 6 Bulan',
    text: 'Komunitasnya sangat aktif dan supportive. Mentor-mentornya profesional dan selalu siap membantu. Trading journal juga membantu saya mengevaluasi setiap kesalahan.',
    stars: 5,
  },
];

function Testimonials() {
  return (
    <section style={{ padding: '100px 0', background: 'var(--bg)' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 60 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="section-label">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0C8F86" strokeWidth="2.5"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" /><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" /><path d="M4 22h16" /><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" /><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" /></svg>
              Testimonial
            </div>
            <h2 style={{ fontSize: 40, fontWeight: 700, color: 'var(--onsurface)', marginBottom: 16, letterSpacing: '-1px' }}>
              Apa Kata Mereka
            </h2>
            <p style={{ fontSize: 16, color: 'var(--text)', maxWidth: 520, margin: '0 auto', lineHeight: 1.7 }}>
              Bergabung dengan ribuan trader Indonesia yang telah merasakan manfaat Tradiora.
            </p>
          </motion.div>
        </div>

        <div className="row">
          {testimonials.map((t, i) => (
            <div className="col-lg-4 col-md-6" key={t.name} style={{ marginBottom: 24 }}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                <div className="testimonial-card">
                  <div className="testimonial-card__stars">
                    {[...Array(t.stars)].map((_, si) => (
                      <Star key={si} size={16} />
                    ))}
                  </div>
                  <p className="testimonial-card__text">"{t.text}"</p>
                  <div className="testimonial-card__author">
                    <div className="testimonial-card__avatar" style={{ background: t.avatarBg }}>
                      {t.avatar}
                    </div>
                    <div>
                      <div className="testimonial-card__name">{t.name}</div>
                      <div className="testimonial-card__role">{t.role}</div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
